import React from "react";

const OrgRoleCell = cellData => {
  return (
    <div>
      <div>
        {cellData.key.contractor && <span>Подрядчик<br/></span>}
        {cellData.key.customer && <span>Заказчик<br/></span>}
        {cellData.key.employer && <span>Работодатель</span>}
      </div>
    </div>
  );
};

export default OrgRoleCell;
